import { APPLICATION_REDUCER_TYPES } from '../../constants';

// Hard coded onboarding next step values for now. Will retrieve this list from BE eventually
const ONBOARDING_NEXT_STEP = {
  BASIC_INFO: "VERIFY_PHONE",
  VERIFY_PHONE: "ADDRESS",
  ADDRESS: "VERIFY_IDENTITY",
  VERIFY_IDENTITY: "LINK_BANK",
  LINK_BANK: "CONFIRM",
  CONFIRM: "CONFIRM",
};

const initialState = {
  currentStep: "BASIC_INFO",
  currentStepIndex: 0,

  // default config orders from onboarding V2
  stepOrder: [
    "BASIC_INFO",
    "VERIFY_PHONE",
    "ADDRESS",
    "VERIFY_IDENTITY",
    "LINK_BANK",
    "CONFIRM",
  ],

  nextSteps: ONBOARDING_NEXT_STEP,
  configVersion: null,
  configFetched: false,
  configSetWithoutUser: true,
};

// eslint-disable-next-line default-param-last
const application = (state = initialState, action) => {
  const {
    SET_CURRENT_STEP,
    SET_JWT,
    SET_ONBOARDING_STEPS,
  } = APPLICATION_REDUCER_TYPES;
  const { type, payload } = action;

  switch(type) {
    // this reducer and the top one are doing the same thing for now but will change later
    // once we introduce different onboarding configs
    case SET_CURRENT_STEP:
      return { ...state, currentStep: payload.step, currentStepIndex: payload.stepIndex };
    case SET_JWT:
      return { ...state, jwt: payload.jwt };
    case SET_ONBOARDING_STEPS:
      return {
        ...state,
        stepOrder: payload.stepOrder,
        nextSteps: payload.nextSteps,
        configVersion: payload.configVersion,
        configSetWithoutUser: payload.configSetWithoutUser,
        configFetched: true,
      };
    default:
      break;
  }

  return state;
};

export default application;